import { useState, useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";

import MaDashboard from "pages/ma/dashboard";
import DeDashboard from "pages/de/dashboard/newDashboard";
import CircularProgress from "@mui/material/CircularProgress";

import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";

import { AccountContext } from "context/account";
import PulseLoader from "react-spinners/PulseLoader";

const DashboardIndex = () => {
  const { account_type } = useContext(AccountContext);
  if (!account_type) {
    return (
      <SuiBox display="flex" alignItems="center" gap={3}>
        <PulseLoader />
        <SuiTypography variant="h6" fontWeight="medium">
          Loading...
        </SuiTypography>
      </SuiBox>
    );
  }

  return account_type == "de" ? <DeDashboard /> : <MaDashboard />;
};

export default DashboardIndex;
